










import { Vue, Component } from 'vue-property-decorator';
import OrdenesSerTec from '@/pantallas/Conecta/OrdenesSerTec/index.vue';

@Component({
  components: { OrdenesSerTec },
})
export default class OrdenesSerTecPantalla extends Vue {}
